import { Exercise } from '../../../entities/exercise/exercise';
import { IExerciseRepository } from '../interfaces/iexercise-repository';

export class InMemoryExerciseRepository implements IExerciseRepository {
    private readonly exercises: Exercise[];
    constructor(exercises: Exercise[]) {
        this.exercises = exercises;
      }

  public async getAll(): Promise<Exercise[]> {
    return this.exercises;
  }

  public async add(exercise: Exercise): Promise<void> {
    this.exercises.push(exercise);
  }

  public get(id: string): Promise<Exercise | undefined> {
    return new Promise<Exercise | undefined>((resolve, reject) => {
      resolve(this.exercises.find((exercise: Exercise) => exercise.uniqueReferenceNumber === id));
    });
  }
}
